export default "__VITE_ASSET__Bv5e4dyp__"